import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MessageCircleIcon, UserIcon, LogOutIcon } from 'lucide-react';
import { useDriver } from '../context/DriverContext';
const TOTAL_BADGES = 20;
export function ProfilePage() {
  const navigate = useNavigate();
  const {
    driverData,
    setDriverData
  } = useDriver();
  if (!driverData) {
    navigate('/login');
    return null;
  }
  const handleLogout = () => {
    setDriverData(null as any);
    navigate('/login');
  };
  return <div className="min-h-screen bg-gray-50 pb-20" data-id="element-228">
      <div className="max-w-lg mx-auto px-4 py-6" data-id="element-229">
        <header className="mb-8" data-id="element-230">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-231">Profil</h1>
        </header>

        <div className="space-y-6" data-id="element-232">
          <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100" data-id="element-233">
            <div className="flex items-center gap-4 mb-6" data-id="element-234">
              <div className="w-16 h-16 bg-gradient-to-br from-amber-100 to-orange-100 rounded-full flex items-center justify-center" data-id="element-235">
                <UserIcon className="w-8 h-8 text-amber-600" data-id="element-236" />
              </div>
              <div data-id="element-237">
                <h2 className="text-xl font-bold text-gray-900" data-id="element-238">
                  {driverData.name}
                </h2>
                <p className="text-sm text-gray-600" data-id="element-239">Chauffeur</p>
              </div>
            </div>

            <div className="space-y-3" data-id="element-240">
              <div className="flex items-center justify-between py-3 border-t border-gray-100" data-id="element-241">
                <span className="text-sm text-gray-600" data-id="element-242">Tickets totaux</span>
                <span className="font-semibold text-gray-900" data-id="element-243">
                  {driverData.tickets}
                </span>
              </div>
              <div className="flex items-center justify-between py-3 border-t border-gray-100" data-id="element-244">
                <span className="text-sm text-gray-600" data-id="element-245">Badges débloqués</span>
                <span className="font-semibold text-gray-900" data-id="element-246">
                  {driverData.badges.filter(b => b.unlocked).length}/
                  {TOTAL_BADGES}
                </span>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-247">
            <button onClick={() => window.open('https://wa.me/2250713893622', '_blank')} className="w-full flex items-center gap-4 p-4 hover:bg-gray-50 transition-colors duration-200" data-id="element-248">
              <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center" data-id="element-249">
                <MessageCircleIcon className="w-6 h-6 text-green-600" data-id="element-250" />
              </div>
              <div className="flex-1 text-left" data-id="element-251">
                <h3 className="font-semibold text-gray-900" data-id="element-252">
                  Support WhatsApp
                </h3>
                <p className="text-sm text-gray-600" data-id="element-253">
                  Contactez-nous pour toute question
                </p>
              </div>
            </button>
          </div>

          <button onClick={handleLogout} className="w-full bg-white border-2 border-red-200 text-red-600 font-semibold py-4 px-6 rounded-xl hover:bg-red-50 hover:border-red-300 transition-all duration-200 flex items-center justify-center gap-2 shadow-sm" data-id="element-254">
            <LogOutIcon className="w-5 h-5" data-id="element-255" />
            <span data-id="element-256">Se déconnecter</span>
          </button>
        </div>
      </div>
    </div>;
}